import { format } from 'date-fns'

// Localized medium date. Locale-driven via date-fns' default locale (set from
// the active i18next language in src/i18n/date-locale). en -> "Jan 1, 2025",
// fr -> "1 janv. 2025".
export const formatDateLong = (date: Date | number | string | null | undefined): string => {
  if (!date) return '-'
  return format(date, 'PP')
}
